import { render, staticRenderFns } from "./Step01.vue?vue&type=template&id=966fc74c"
import script from "./Step01.vue?vue&type=script&lang=js"
export * from "./Step01.vue?vue&type=script&lang=js"
import style0 from "./Step01.vue?vue&type=style&index=0&id=966fc74c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports